export default "__VITE_ASSET__B1$e9xfL__"